import React from 'react';
import { useCursor } from '../context/CursorContext';
import { AnimatedSection, StaggerChildren } from '../components/AnimatedSection';
import { TiltCard } from '../components/TiltCard';
import { partners } from '../data/mock';

export default function PartnerDealsPage() {
  const { setLabel } = useCursor();

  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-5xl mx-auto">
        <AnimatedSection className="text-center mb-16">
          <p className="text-green-500 font-semibold uppercase tracking-[0.3em] mb-3 text-xs">Exclusive</p>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-3">PARTNER DEALS</h1>
          <p className="text-white/40">Exclusive deals for the Moon Media community.</p>
          <div className="mt-4 mx-auto w-16 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent" />
        </AnimatedSection>

        <StaggerChildren className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" staggerDelay={100}>
          {partners.map((partner) => (
            <TiltCard
              key={partner.id}
              cursorLabel={partner.active ? "Get Deal" : ""}
              className={`group p-6 border ${partner.active ? 'border-green-500/30 bg-green-500/5 hover:border-green-500/50' : 'border-white/5 bg-white/[0.02] opacity-60'}`}
            >
              <p className="text-[10px] text-green-500 uppercase tracking-wider">{partner.type}</p>
              <h3 className="text-2xl font-black text-white mt-1 mb-3">{partner.name}</h3>
              <p className={`mb-4 text-sm ${partner.active ? 'text-white/60' : 'text-white/30'}`}>{partner.deal}</p>
              {partner.active && partner.url ? (
                <a
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-green-500 text-xs font-semibold uppercase tracking-wider hover:text-green-400 transition-colors duration-300"
                  onMouseEnter={() => setLabel('Claim')}
                  onMouseLeave={() => setLabel('')}
                >
                  Claim Offer
                  <span className="group-hover:translate-x-1 transition-transform duration-300">&rarr;</span>
                </a>
              ) : (
                <span className="inline-flex items-center gap-1 text-white/20 text-xs font-semibold uppercase tracking-wider">Coming Soon</span>
              )}
            </TiltCard>
          ))}
        </StaggerChildren>
      </div>
    </div>
  );
}
